<template>
  <nav>
    <v-navigation-drawer
    v-model="drawer"
      dark
      src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTXRylJTyHTk4y_9HI5AkPTeNJH--7jBOS2eut1QFtXPAdVFhy1-pIIMOmMcOJt6Pwg0hc&usqp=CAU"
      app
      :mini-variant.sync="mini"
      >
  <template v-slot:prepend>
        <v-list-item class="px-2">
          <v-list-item-avatar>
            <img src="https://www.mod.gov.my/images/mindef/header_utama/jata.png">
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title>Ministry of Defence<br>( Server Room <br>Monitoring )</v-list-item-title>
          
          </v-list-item-content>
           <v-btn
          icon
          @click.stop="mini = !mini"
        >
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
        </v-list-item>
      </template>

      <v-divider></v-divider>
      <v-list nav>

        <v-list disabled>
          <v-list-item
             v-for="item in overview" :key="item.title" link :to="item.path"
          >
          <v-list-item-icon>
            <v-icon style="color:grey">mdi-view-dashboard</v-icon>
          </v-list-item-icon>
             <v-list-item-content>
            <v-list-item-title><span style="color:grey">{{ item.title }}</span></v-list-item-title>
          </v-list-item-content>
          </v-list-item>
      </v-list>

        <v-list-group
        :value="false"
        prepend-icon="mdi-weather-windy"
      >
        <template v-slot:activator>
          <v-list-item-title><span>Air Quality</span></v-list-item-title>
        </template>

          <v-list-item
             v-for="item in airQuality" :key="item.title" link :to="item.path"
          >
           <v-list-item-icon>
          </v-list-item-icon>
             <v-list-item-content>
            <v-list-item-title><v-icon>{{ item.icon }}</v-icon>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
          </v-list-item>
      </v-list-group>

      <v-list-group
        :value="false"
        prepend-icon="mdi-lightning-bolt"
        disabled
      >
        <template v-slot:activator>
          <v-list-item-title><span style="color:grey">Energy</span></v-list-item-title>
        </template>

          <v-list-item
             v-for="item in energy" :key="item.title" link :to="item.path"
          >
             <v-list-item-content>
            <v-list-item-title> <v-icon>{{ item.icon }}</v-icon>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
          </v-list-item>
      </v-list-group>

      <v-list-group
        :value="false"
        prepend-icon="mdi-water"
        disabled
      >
        <template v-slot:activator>
          <v-list-item-title><span style="color:grey">Water Flow</span></v-list-item-title>
        </template>

          <v-list-item
             v-for="item in waterFlow" :key="item.title" link :to="item.path"
          >
             <v-list-item-content>
            <v-list-item-title> <v-icon>{{ item.icon }}</v-icon>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
          </v-list-item>
      </v-list-group>

      
      <v-list-group
        :value="false"
        prepend-icon="mdi-cup-water"
        disabled
      >
        <template v-slot:activator>
          <v-list-item-title><span style="color:grey">Water Tank</span></v-list-item-title>
        </template>

          <v-list-item
             v-for="item in waterTank" :key="item.title" link :to="item.path"
          >
          <v-list-item-icon>
          </v-list-item-icon>
             <v-list-item-content>
            <v-list-item-title><v-icon>{{ item.icon }}</v-icon>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
          </v-list-item>
      </v-list-group>

       <v-list-group
        :value="false"
        prepend-icon="mdi-cog"
        disabled
      >
        <template v-slot:activator>
          <v-list-item-title><span style="color:grey">Settings</span></v-list-item-title>
        </template>

          <v-list-item
             v-for="item in manage" :key="item.title" link :to="item.path"
          >
          <v-list-item-icon>
            
          </v-list-item-icon>
             <v-list-item-content>
            <v-list-item-title><v-icon>{{ item.icon }}</v-icon>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
          </v-list-item>
      </v-list-group>

      <v-list>
          <v-list-item
             v-for="item in manageAsset" :key="item.title" link :to="item.path"
          >
          <v-list-item-icon>
            <v-icon>mdi-application</v-icon>
          </v-list-item-icon>
             <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
          </v-list-item>
      </v-list>

      <v-list>
          <v-list-item
             v-for="item in doorSecurity" :key="item.title" link :to="item.path"
          >
          <v-list-item-icon>
            <v-icon>mdi-shield-lock</v-icon>
          </v-list-item-icon>
             <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
          </v-list-item>
      </v-list>
      </v-list>
      <template v-slot:append v-if="!mini">
        <div class="pa-2">
          <v-btn block 
          color="red"
          @click="$keycloak.logoutFn"
          v-if="$keycloak.authenticated">
            Sign Out
        <v-icon
        right
        dark>
        mdi-logout-variant
      </v-icon>
          </v-btn>
        </div>
      </template>
    </v-navigation-drawer>
  </nav>
</template>

<script>
export default {
  data() {
      return {
        drawer: true,
        mini: false,
      manageAsset: [
        {title: 'Manage Asset', path:'/' },
      ],
      doorSecurity: [
        {title: 'Security Door', path:'/security-door' },
      ],
      overview: [
        {title: 'Overview', icon: 'mdi-chevron-right', path:'/overview' },
      ],
      energy: [
        {title: 'Usage by Phase', icon: 'mdi-chevron-right', path:'/usage-by-phase-energy' },
        {title: 'Usage by Location', icon: 'mdi-chevron-right', path:'/usage-by-location-energy' },
        {title: 'Usage by DB-MCB', icon: 'mdi-chevron-right', path:'/usage-by-db-energy' },
        {title: 'Usage by DB', icon: 'mdi-chevron-right', path:'/usage-by-db-total-energy' },
      ],
      waterFlow: [
        {title: 'Usage by Location', icon: 'mdi-chevron-right', path:'/usage-by-location-water-flow' },
      ],
      waterTank: [
        {title: 'Overview', icon: 'mdi-chevron-right', path:'/overview-water-tank' },
      ],
      airQuality: [
        {title: 'Overview', icon: 'mdi-chevron-right', path:'/overview-air-quality' },
        {title: 'AQ By Location', icon: 'mdi-chevron-right', path:'/aq-by-location' },
      ],
      manage: [
        {title: '8 Channel Phase', icon: 'mdi-chevron-right', path:'/board' },
        {title: 'Single Phase', icon: 'mdi-chevron-right', path:'/single-phase' },
        {title: 'Water Flow', icon: 'mdi-chevron-right', path:'/water-board' },
        {title: 'Tank Water Level', icon: 'mdi-chevron-right', path:'/water-tank' },
        {title: 'Air Quality', icon: 'mdi-chevron-right', path:'/air-quality'},
        {title: 'Location', icon: 'mdi-chevron-right', path:'/location' },
        {title: 'Meter', icon: 'mdi-chevron-right', path:'/meter' },
      ],
      };
  },
  computed: {
    loginUser() {
      return this.$store.getters["loginUser/getDetails"];
    },
  },
  created: function() {
    this.$store.dispatch("loginUser/setCurrentUser", {
      firstName: this.$keycloak.tokenParsed.given_name,
      lastName: this.$keycloak.tokenParsed.family_name,
    }); 
}
}

</script>

<style scoped>

</style>